import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class DataService {

    private dataToShare = new BehaviorSubject('');
    sharedData = this.dataToShare.asObservable();

    private userProfilePhoto = new BehaviorSubject('');
    currentUserProfilePhoto = this.userProfilePhoto.asObservable();

    private userProfileName = new BehaviorSubject('');
    currentUserProfileName = this.userProfileName.asObservable();

    public dataShared: BehaviorSubject<any> = new BehaviorSubject<any>(0);

    public userLoginShared: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  


  constructor() { }

  shareData(value: any) {
    this.dataToShare.next(value)
  }

  changeuserprofilephoto(value: any) {
    this.userProfilePhoto.next(value)
  }


  changeuserprofilename(value: any) {
    // console.log('called changeuserprofilename');
    this.userProfileName.next(value)
  }

  getSharedData(): Observable<any> {
    return this.dataShared.asObservable();
  }
  setSharedData(data: any) {
    this.dataShared.next(data);
  }
  
  getUserLoginSharedData(): Observable<any>{
    return this.userLoginShared.asObservable();
  }

  setUserLoginSharedData(data: any){
    this.userLoginShared.next(data);
  }

}//end class